<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Matricola" v-model="element.registration" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Capacità" v-model="element.capacity" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Utilizzo"
        v-model="element.usage"
        :options="['Acqua calda sanitaria', 'Riscaldamento', 'Raffrescamento']"
        multiple
      />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Coibentazione"
        v-model="element.insulation"
        :options="['Assente', 'Presente']"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>